<script setup>
import moment from 'moment';
import { computed, onMounted, ref } from 'vue';
import PresenceInputTime from './PresenceInputTime.vue';

const day = computed(() => {
    if (props.day) {
        const formatted = moment(props.day, 'DD-MM-YYYY').format('DD [de] MMMM [de] YYYY');
        return formatted.replace(/(\sde\s)(\p{L})/u, (_, prefix, letter) => prefix + letter.toUpperCase());
    } else {
        return 'DD-MM-YYYY'
    }
});
const selected = ref(false);
const entriesOriginal = computed(() => {
    return props.requests.originalWorkRecords.filter((item) => item.type === 'entry' || item.type === 'resume')
})
const exitsOriginal = computed(() => {
    return props.requests.originalWorkRecords.filter((item) => item.type === 'exit' || item.type === 'pause')
})
const entriesRequests = computed(() => {
    return requested.value.filter((item) => item.type === 'entry' || item.type === 'resume')
})
const exitsRequests = computed(() => {
    return requested.value.filter((item) => item.type === 'exit' || item.type === 'pause')
})

const hasOriginalDay = computed(() => {
    return entriesOriginal.value.length > 0 || exitsOriginal.value.length > 0
})

const isApprovedOrRejected = computed(() => {
    if (props.requests.workRecordRequests.length > 0) {
        const temp = props.requests.workRecordRequests[0];
        return temp.status === 'rejected' || temp.status === 'approved';
    }
    return false;
})

const fullDays = computed(() => {
    return mergeAndSortRecords(props.requests.originalWorkRecords, props.requests.workRecordRequests);
})

// eslint-disable-next-line no-unused-vars
const requested = computed(() => {
    const temp = [];
    for (let i = 0; i < fullDays.value.length; i++) {
        const element = fullDays.value[i];
        if (element.requests && element.requests.length > 0) {
            temp.push(element.requests[0].request)
        } else {
            if (element.original) {
                const temp2 = element.original;
                if (!temp2.requestedRecordedAt) {
                    temp2.requestedRecordedAt = temp2.recordedAt;
                }
                temp.push(element.original)
            }
        }
    }
    return temp;
})
// eslint-disable-next-line no-undef
const props = defineProps({
    day: String,
    modelValue: { type: Boolean, default: false },
    requests: Object,
    admin: {
        type: Boolean,
        default: false,
    }
})

// eslint-disable-next-line no-undef
const emit = defineEmits(['update:modelValue']);

onMounted(() => {

    if (props.modelValue) {
        selected.value = props.modelValue;
    } else {
        select(false);
    }
})

const mergeAndSortRecords = (originalWorkRecords, workRecordRequests) => {
    const map = new Map();
    originalWorkRecords.forEach(orig => {
        const key = orig['@id'];
        map.set(key, {
            type: 'original',
            recordedAt: orig.recordedAt,
            original: orig,
            requests: []
        });
    });
    workRecordRequests.forEach(req => {
        const { requestType, originalWorkRecord } = req;
        const reqDate = req.requestedRecordedAt;

        if (requestType === 'modification') {
            let origId
            if (originalWorkRecord && originalWorkRecord['@id']) {
                origId = originalWorkRecord['@id'];
            } else {
                origId = originalWorkRecord;
            }

            if (map.has(origId)) {
                const entry = map.get(origId);
                entry.requests.push({ type: 'modification', request: req });
            } else {
                map.set(req['@id'], {
                    type: 'new',
                    recordedAt: reqDate,
                    original: null,
                    requests: [{ type: 'new', request: req }]
                });
            }
        } else if (requestType === 'new') {
            map.set(req['@id'], {
                type: 'new',
                recordedAt: reqDate,
                original: null,
                requests: [{ type: 'new', request: req }]
            });
        }
    });
    const arr = Array.from(map.values());
    arr.sort((a, b) => new Date(a.recordedAt) - new Date(b.recordedAt));

    return arr;
}

// Cambiar el boton de aceptar y denegar
const select = (option) => {
    selected.value = option;
    emit('update:modelValue', option)
}

</script>

<template>
    <div class="card">
        <div class="card-body">
            <div class="row justify-content-between ">
                <div class="col-8">
                    <h3 class="title d-flex justify-content-start align-content-start">Día {{ day }}</h3>
                </div>
            </div>
            <div v-if="hasOriginalDay">
                <div class="row justify-content-between ">
                    <div class="col-8">
                        <h3 class="title d-flex justify-content-start align-content-start">Fichajes Actuales</h3>
                    </div>
                </div>
                <div class="row d-flex align-items-start mt-2">
                    <div class="col-6">
                        <h5 class="change-title">Entrada</h5>
                    </div>
                    <div class="col-6">
                        <h5 class="change-title">Salida</h5>
                    </div>
                </div>
                <div class="row d-flex align-items-start">
                    <div class="col-6">
                        <ul>
                            <li v-for="item in entriesOriginal" :key="item.id" class="mt-2">
                                <PresenceInputTime :presenceHour="new Date(item.recordedAt)" :disabled="true" :presenceType="item.type"/>
                            </li>
                        </ul>
                    </div>
                    <div class="col-6">
                        <ul>
                            <li v-for="item in exitsOriginal" :key="item.id" class="mt-2">
                                <PresenceInputTime :presenceHour="new Date(item.recordedAt)" :disabled="true" :presenceType="item.type" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row justify-content-between mt-4 changes-body">
                <div class="col-8 el-col-xs-14">
                    <h3 class="title d-flex justify-content-start align-content-start">Cambios solicitados</h3>
                </div>
                <!-- Botones de aceptar y denegar -->
                <div class="row col-4 ms-auto justify-content-end el-col-xs-10 d-flex" v-if="admin && !isApprovedOrRejected">
                    <div class="col-auto" style="margin-right: -34px;"> <el-tooltip class="box-item" effect="dark"
                            content="Rechazar" placement="top">
                            <button class="btn rounded-circle d-flex align-items-center justify-content-center"
                                :class="!selected ? 'btn-cancel' : 'btn-unselected-cancel'"
                                style="width: 30px; height: 30px;" @click="select(false)">
                                <i class="fas fa-times text-white"></i>
                            </button>
                        </el-tooltip>
                    </div>
                    <div class="col-auto" style="margin-right: -10px;">
                        <el-tooltip class="box-item" effect="dark" content="Aceptar" placement="top">
                            <button class="btn rounded-circle d-flex align-items-center justify-content-center"
                                :class="selected ? 'btn-approve' : 'btn-unselected-success'"
                                style="width: 30px; height: 30px;" @click="select(true)">
                                <i class="fas fa-check text-white"></i>
                            </button>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <div class="row d-flex align-items-start mt-2">
                <div class="col-6">
                    <h5 class="change-title">Entrada</h5>
                </div>
                <div class="col-6">
                    <h5 class="change-title">Salida</h5>
                </div>
            </div>
            <div class="row d-flex align-items-start">
                <div class="col-6">
                    <ul>
                        <li v-for="item in entriesRequests" :key="item.id" class="mt-2">
                            <PresenceInputTime
                                :presenceHour="item.requestedRecordedAt ? new Date(item.requestedRecordedAt) : new Date(item.recordedAt)"
                                :presenceType="item.type"
                                :myClass="item.status === 'rejected' ? item.status : item.requestType"
                                :disabled="true" />
                        </li>
                    </ul>
                </div>
                <div class="col-6">
                    <ul>
                        <li v-for="item in exitsRequests" :key="item.id" class="mt-2">
                            <PresenceInputTime :presenceHour="new Date(item.requestedRecordedAt)"
                                :myClass="item.status === 'rejected' ? item.status : item.requestType"
                                :presenceType="item.type" :disabled="true" />
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>
</template>

<style lang="scss" scoped>
.title {
    color: $font-blue-color;
    font-weight: 800;
    font-size: 24px;
    margin-right: -30px;
}

.temp {
    width: 100%;
    padding: 10px;
    border-radius: 0.8em;
    background-color: white;
}

.btn-unselected-success {
    background-color: #474747;
    color: white;
}

.btn-unselected-cancel {
    background-color: #474747;
    color: white;
}

.btn-cancel {
    background-color: #F9156F;
    color: white;
}

.btn-approve {
    background-color: #474CE6;
    color: white;
}

.change-title {
    font-weight: 800;
    font-size: 22px;
    letter-spacing: -5%;
    margin-bottom: -.5rem !important;
    margin-left: 10px;
}

@media (max-width: 625px) {
    .title {
        font-size: 18px;
        margin-right: -100px;
        margin-top: 5px;
    }
    .change-title{
        font-size: 16px;
        margin-left: 18px;
    }
    .changes-body{
        margin-top: 0px !important;
    }
}
</style>